import Button from "components/Button";
import { motion } from "framer-motion";
import { useAppScroll } from "hooks";
import React from "react";
import styles from "./styles.module.scss";

const Footer: React.FC = () => {
  const { scrollTo } = useAppScroll();

  return (
    <motion.div className={styles.container}>
      {"Copyright © 2025 • "}
      <Button
        className={styles.button}
        onClick={() => scrollTo({ elementId: "home" })}
        href="/home"
        type="link"
      >
        Renewable PH
      </Button>
      {" • All rights reserved."}
    </motion.div>
  );
};

export default Footer;
